import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IFlatViewOrderInfoProps {
  description: string;
}

export function FlatViewOrderInfo({ description }: IFlatViewOrderInfoProps) {
  return (
    <div className={styles['notification']}>
      <div className={styles['calendar']} />
      <InlineText2>{description}</InlineText2>
    </div>
  );
}
